import { Text, type TextProps } from "../../../primitives";

type StepFieldLabelProps = TextProps & {
	required?: boolean;
};

export const StepFieldLabel = ({ required, children, ...props }: StepFieldLabelProps) => (
	<Text type="body-strong" color="secondary" {...props}>
		{children}
		{required && <Text color="danger">{"\u00A0"}*</Text>}
	</Text>
);
